<template>
    <tr id="summary_row" :class="`border-line ${summary.id === viewScheduleId ? 'edit-row td-border' : ''}`">
        <td>
            <div class="employee-cell">
                <span class="employee-name">{{ summary.name }}</span
                ><span class="expand-icon" @click="handleViewSchedule(summary)" v-if="summary.id !== viewScheduleId"
                    ><i class="fa-regular fa-square-plus"></i>
                </span>
                <span v-else class="expand-icon"
                    ><i class="fa-regular fa-square-minus" @click="handleCloseViewSchedule()"></i
                ></span>
            </div>
        </td>
        <td v-for="countData in summary.userSummaryData" v-if="summary.userSummaryData.length">
            <span v-if="countData.TotalVisits || countData.TotalHours">
                {{ `V:${countData.TotalVisits}/ H:${countData.TotalHours}` }}
            </span>
        </td>
        <td v-else v-for="i in 7"></td>
        <td>{{ `V: ${summary.totalVisits} / H: ${summary.totalHours}` }}</td>
    </tr>

    <tr v-if="isViewScheduleRequested" class="edit-row">
        <td :colspan="columns" class="p-3 edit">
            <table class="table table-responsive-md border border-gray">
                <thead>
                    <tr class="bg-table-header table-header">
                        <th>
                            <SortableTh
                                :sort-by="sortBy"
                                v-on:sortByUpdated="sortByUpdated"
                                :sort-order="sortOrder"
                                v-on:sortOrderUpdated="sortOrderUpdated"
                                sort-string="taskName"
                            >
                                Task
                            </SortableTh>
                        </th>
                        <th>
                            <SortableTh
                                :sort-by="sortBy"
                                v-on:sortByUpdated="sortByUpdated"
                                :sort-order="sortOrder"
                                v-on:sortOrderUpdated="sortOrderUpdated"
                                sort-string="agencyName"
                            >
                                Agency
                            </SortableTh>
                        </th>
                        <th>
                            <SortableTh
                                :sort-by="sortBy"
                                v-on:sortByUpdated="sortByUpdated"
                                :sort-order="sortOrder"
                                v-on:sortOrderUpdated="sortOrderUpdated"
                                sort-string="branchName"
                            >
                                Branch
                            </SortableTh>
                        </th>
                        <th>
                            <SortableTh
                                :sort-by="sortBy"
                                v-on:sortByUpdated="sortByUpdated"
                                :sort-order="sortOrder"
                                v-on:sortOrderUpdated="sortOrderUpdated"
                                sort-string="patientName"
                            >
                                Patient Name
                            </SortableTh>
                        </th>
                        <th>
                            <SortableTh
                                :sort-by="sortBy"
                                v-on:sortByUpdated="sortByUpdated"
                                :sort-order="sortOrder"
                                v-on:sortOrderUpdated="sortOrderUpdated"
                                sort-string="startDate"
                            >
                                Scheduled Date
                            </SortableTh>
                        </th>
                        <th>Scheduled Time</th>
                        <th>Hours</th>
                        <th>Status</th>
                        <th v-show="schedulesIncludesHHOrHCVisit">EVV</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="table-empty fw-normal" v-if="!sortedSchedules.length">
                        <td :colspan="columns">
                            <h3>No Tasks Found.</h3>
                        </td>
                    </tr>
                    <tr v-else class="border-line fw-normal" v-for="schedule in sortedSchedules" :key="schedule.Id">
                        <td>
                            {{ schedule.TaskName }}
                        </td>
                        <td>
                            <ProductPill :productId="schedule.Application === 256 ? -3 : schedule.Application" />
                            {{ schedule.AgencyName }}
                        </td>
                        <td>
                            {{ schedule.BranchName }}
                        </td>
                        <td>{{ getPatientName(schedule) }}</td>
                        <td>
                            {{ formatDate(schedule.StartDate, "MM/DD/YYYY") }}
                        </td>
                        <td>
                            {{ getTime(schedule) }}
                        </td>
                        <td>{{ getHour(schedule) }}</td>
                        <td>{{ schedule.Status }}</td>
                        <td class="emp_summary_evv" v-show="schedulesIncludesHHOrHCVisit">
                            <span @click="openEvvHouse(schedule)" style="cursor: pointer">
                                <a :class="getEvvButtonClass(schedule)"><i :class="getEvvIconClass(schedule)"></i></a>
                            </span>
                        </td>
                        <td>
                            <span class="btn-group table-btn-group" v-if="hasAnyAction(schedule)">
                                <button
                                    type="button"
                                    class="btn btn-xs px-1 py-0 btn-outline-primary dropdown-toggle"
                                    data-bs-toggle="dropdown"
                                >
                                    <i class="fas fa-ellipsis-h"></i>
                                </button>
                                <div class="dropdown-menu dropdown-transform-right">
                                    <a
                                        v-if="canReassign(schedule)"
                                        class="dropdown-item"
                                        href="javascript:void(0);"
                                        @click="scheduledVisit(schedule)"
                                    >
                                        Reassign
                                    </a>
                                    <a
                                        v-if="canViewDetails(schedule)"
                                        class="dropdown-item"
                                        href="javascript:void(0);"
                                        @click="showVisitDetails(schedule)"
                                    >
                                        Details
                                    </a>
                                    <a
                                        v-if="canViewProfile(schedule)"
                                        class="dropdown-item"
                                        href="javascript:void(0);"
                                        @click="openProfile(schedule)"
                                    >
                                        Profile
                                    </a>
                                    <a
                                        v-if="canGoToPatientChart(schedule)"
                                        class="dropdown-item"
                                        href="javascript:void(0);"
                                        @click="handlePatientNameClick(schedule)"
                                    >
                                        Patient Chart
                                    </a>
                                    <a
                                        v-if="canDelete(schedule)"
                                        class="dropdown-item"
                                        href="javascript:void(0);"
                                        @click="deleteTask(schedule)"
                                    >
                                        Delete
                                    </a>
                                </div>
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </td>
    </tr>
</template>

<script lang="ts" src="./SummaryViewRow.ts"></script>
